import type { AppContext, AppEvents } from "@/types/scheduling";

import { assertEvent } from "xstate";

export const handleAssignRDEData = <T extends AppContext, E extends AppEvents>(context: T, event: E) => {
  assertEvent(event, "xstate.done.actor.getRDEActor");
  console.debug("handleAssignRDEData", event.output)
  return {
    ...context,
    provider_data_raw: event.output.rds,
    wanted_expertise: event.output.match_criteria?.wanted_expertise || [],
  }
}
